import React from 'react';

export default function CostOfInaction() {
  return (
    <section className="section-padding bg-zinc-100 border-y border-zinc-200 relative overflow-hidden">
      <div className="absolute right-[-20%] top-1/2 -translate-y-1/2 w-[60%] h-[150%] opacity-[0.05] pointer-events-none z-0">
        <img
          src="https://media-manager-c.questera.ai/greta-media/471e332637c745cac6e5f952a1669a461aea7ff8853c3b4ee7dd2b5f799ce1f00d91c0ccf6cd346bf4393cbd10a6b0de/images/aW1hZ2UvcG5n/b0aeda3f71e063316c13c730fd9fa7d7.png"
          alt=""
          className="w-full h-full object-contain"
        />
      </div>

      <div className="max-w-4xl mx-auto text-center relative z-10">
        <span className="text-brand-red font-bold uppercase tracking-widest text-sm mb-4 block">
          คำถามที่ควรถามตัวเอง
        </span>

        <h2 className="text-4xl md:text-5xl font-black text-zinc-900 mb-8 leading-tight">
          ถ้าไม่เริ่มวันนี้ <br /> อีก 10 ปีข้างหน้าจะเป็นอย่างไร?
        </h2>

        <p className="text-xl text-zinc-700 mb-12 leading-relaxed font-medium">
          ดวงจรของคุณเดินหน้าอยู่ตลอดเวลา ไม่ว่าคุณจะรู้จักมันหรือไม่ก็ตาม
          การรอ "ให้พร้อมกว่านี้" หรือ "ให้มีเงินก้อนก่อน"
          มักหมายถึงการปล่อยให้ช่วงจังหวะที่ดีที่สุดของดวงคุณผ่านไปโดยไม่ได้ใช้ประโยชน์
          — และรุ่นนี้เปิดรับเพียง 39 ที่นั่ง เมื่อเต็มแล้วจะต้องรอรุ่นถัดไปซึ่งยังไม่มีกำหนดวันที่แน่นอน
        </p>

        <div className="pt-10 border-t-2 border-zinc-200">
          <p className="text-2xl md:text-3xl font-black text-zinc-900">
            "โอกาสไม่ได้รอทุกคน — แต่ดวงของคุณ{' '}
            <span className="text-brand-red">รอให้คุณมาทำความเข้าใจมันเสมอ</span>"
          </p>
        </div>
      </div>
    </section>
  );
}